// extracted by mini-css-extract-plugin
module.exports = {"volumeCheckbox":"checkbox_volumeCheckbox__3-xwf"};